import { IDocumentModel } from "./../../interfaces/document-model";
import { ITabDefinition } from "./../../interfaces/tab-definition";
import { FulltextTabState } from "./fulltext-state";
import { JudgmentTabState } from "./judgment-tab-state";
import { GenericTabModel } from "./generic-tab";
import {prop} from "../../../decorators/property";

export class FulltextTabModel extends GenericTabModel {

    @prop() public State: FulltextTabState = new FulltextTabState();
    public constructor(properties: ITabDefinition, data: IDocumentModel) {
        super(properties, data);
        this.set("CoreProduct", data.get("CoreProduct")); // For the restricted sku message "Canada Core is not included in your subscription"
    }
    public get Enabled(): boolean {
        return this.Data.HasFullTextOrPdf;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/tabs/fulltext.ts